import {
  Component,
  ElementRef,
  EventEmitter,
  Input,
  OnInit,
  Output,
  ViewChild,
} from "@angular/core";
import { ActivatedRoute, Router, Params } from "@angular/router";
import { ModalController, ToastController } from "@ionic/angular";
import { MatDialogRef } from "@angular/material/dialog";
import { FormArray, FormControl, FormGroup, Validators } from "@angular/forms";
import { MasterService } from "src/app/services/master.service";
import { CorrigendumRequestModel } from "src/app/model/CorrigendumRequestModel";
import { CorrigendumUploadModel } from "src/app/model/CorrigendumUploadModel";
import { MatSnackBar } from "@angular/material/snack-bar";
import { TenementExchangeOtpModel } from "src/app/model/TenementExchangeOtpModel";
import { LoginService } from "src/app/services/login.service";

@Component({
  selector: "app-modal",
  templateUrl: "./edit-modal.component.html",
  styleUrls: ["./edit-modal.component.scss"],
})
export class TenementEditModalComponent implements OnInit {
  form: FormGroup = new FormGroup({});
  isLoading = false;
  pageMode: string;

  @Input() key: any;

  isSubmitDisabled: boolean = false;
  @Output() dataModal = new EventEmitter<string>();

  constructor(
    private modalCtrl: ModalController,
    private masterService: MasterService,
    private router: Router,
    private _snackBar: MatSnackBar
  ) {}

  ngOnInit() {
    this.isSubmitDisabled = false;
    console.log("key for edit", this.key);

    this.masterService.fetchEditDetails(this.key).subscribe(
      async (data: any) => {
        this.isLoading = false;
        if (data.status === "SUCCESS") {
          this.form.patchValue({
            // mahareraNo: data.mahareraNo,
            // location: data.location,
            incomeGrpType: data.incomeGrpType,
            propertyType: data.propertyType,
            // ctsNo: data.ctsNo,
            buildingNo: data.buildingNo,
            flatNo: data.flatNo,
            builtupArea: data.builtupArea,
            carpetArea: data.carpetArea,
            cost: data.cost,
            maintainCost: data.maintenanceCost,
            blocked: data.blocked,
            remarks: data.remarks,
            wing: data.wing,
            floor: data.floor,
          });
        } else {
          this.masterService.errorToast("Failed to Fetch Details");
        }
      },

      (error) => {
        this.isLoading = false;
        this.masterService.errorToast("Failed to Fetch Details");
      }
    );

    this.form = new FormGroup({
      // mahareraNo: new FormControl(null, [
      //   Validators.required,
      //   Validators.maxLength(20),
      // ]),
      // location: new FormControl(null, [
      //   Validators.required,
      //   Validators.maxLength(200),
      // ]),
      incomeGrpType: new FormControl(null, [
        Validators.required,
        Validators.maxLength(200),
      ]),
      propertyType: new FormControl(null, [
        Validators.required,
        Validators.maxLength(100),
      ]),
      // ctsNo: new FormControl(null, [
      //   Validators.required,
      //   Validators.maxLength(20),
      // ]),
      buildingNo: new FormControl(null, [
        Validators.required,
        Validators.maxLength(20),
      ]),
      flatNo: new FormControl(null, [
        Validators.required,
        Validators.maxLength(10),
      ]),
      builtupArea: new FormControl(null, [
        Validators.required,
        Validators.maxLength(20),
      ]),
      carpetArea: new FormControl(null, [
        Validators.required,
        Validators.maxLength(20),
      ]),
      cost: new FormControl(null, [
        Validators.required,
        Validators.maxLength(10),
      ]),
      maintainCost: new FormControl(null, [Validators.maxLength(10)]),
      blocked: new FormControl(null, [
        Validators.required,
        Validators.maxLength(1),
      ]),
      remarks: new FormControl(null, [Validators.maxLength(500)]),
      wing: new FormControl(null, [
        Validators.required,
        Validators.maxLength(10),
      ]),
      floor: new FormControl(null, [
        Validators.required,
        Validators.maxLength(10),
      ]),
    });
  }

  cancel() {
    this.modalCtrl.dismiss(null, "cancel");
  }

  resetFilter() {
    // window.location.reload();
    this.modalCtrl.dismiss(null, "cancel");
  }

  // verifyOtp() {
  //   this.masterService
  //     .verifyOtp(
  //       this.luser,
  //       this.fromApplicantData.applicationNo,
  //       this.toApplicantData.applicationNo
  //     )
  //     .subscribe(
  //       (data: any) => {
  //         console.log(data.status == "FAILURE");
  //         if (data.status == "SUCCESS") {
  //           this.onSaveTenementDetails();
  //         }
  //         if (data.status == "FAILURE") {
  //           console.log("Check data for failure", data);
  //           alert(data.errorMessage);
  //         }
  //       },
  //       (error) => {
  //         alert("Invalid OTP");
  //         this._snackBar.open("Invalid username or password", "Close", {
  //           horizontalPosition: "right",
  //           verticalPosition: "top",
  //           panelClass: "warning-toast",
  //           duration: 3 * 1000,
  //         });
  //       }
  //     );
  // }

  saveEditDetails() {
    console.log("this.form.valid", this.form.valid);

    if (this.form.valid) {
      const formData = this.form.value;
      const masterEditData = {
        key: this.key,
        // mahareraNo: formData.mahareraNo,
        // location: formData.location,
        incomeGrpType: formData.incomeGrpType,
        propertyType: formData.propertyType,
        // ctsNo: formData.ctsNo,
        buildingNo: formData.buildingNo,
        flatNo: formData.flatNo,
        builtupArea: formData.builtupArea,
        carpetArea: formData.carpetArea,
        cost: formData.cost,
        maintainCost: formData.maintainCost,
        blocked: formData.blocked,
        remarks: formData.remarks,
        wing: formData.wing,
        floor: formData.floor,
      };
      this.modalCtrl.dismiss(masterEditData, "submit");
    } else {
      // this.masterService.errorToast("All Fields are Required !");
      Object.keys(this.form.controls).forEach((key) => {
        const control = this.form.get(key);
        if (control.invalid) {
          let errorMessage = "";
          if (control.errors.required) {
            errorMessage = `${key} is required`;
          } else if (control.errors.maxlength) {
            errorMessage = `${key} should not exceed ${control.errors.maxlength.requiredLength} characters`;
          }
          this.masterService.errorToast(errorMessage);
          return;
        }
      });
    }
  }

  async errorToast(errorMessage: string, dur?: number) {
    await this._snackBar.open(errorMessage, "Close", {
      horizontalPosition: "right",
      verticalPosition: "top",
      panelClass: "error-toast",
      duration: dur ? dur : 3 * 1000,
    });
  }

  async successToast(msg) {
    await this._snackBar.open(msg, "Close", {
      horizontalPosition: "right",
      verticalPosition: "top",
      panelClass: "success-toast",
      duration: 3 * 1000,
    });
  }
}
